import React, { useEffect, useState } from "react";

const DisplayType3 = ({
    test,
    phrases,
    setnextDisable,
    setSelectedAns1,
    setSelectedAns2,
    setSelectedAns3,
    setSelectedAns4,
    selectedC,
    selectedAns1,
    selectedAns2,
    selectedAns3,
    selectedAns4,
}) => {
    const [refresh, setRefresh] = useState(true);
    const chunk1 = test.questions[0].answers;
    
    useEffect(() => {
        if (
            selectedAns1 === -1 &&
            selectedAns2 === -1 &&
            selectedAns3 === -1 &&
            selectedAns4 === -1
        )
            setnextDisable(true);
        setRefresh((prev) => !prev);
    }, [selectedC]);

    const handlenextNavigateDis = () => {
        setnextDisable(false);
    };

    const handleChunks1 = (e) => {
        setSelectedAns1(e);
        handlenextNavigateDis();
    };

    const handleChunks2 = (e) => {
        setSelectedAns2(e);
        handlenextNavigateDis();
    };

    const handleChunks3 = (e) => {
        setSelectedAns3(e);

        handlenextNavigateDis();
    };

    const handleChunks4 = (e) => {
        setSelectedAns4(e);
        handlenextNavigateDis();
    };

    return (
        <React.Fragment key={refresh}>
            <fieldset className="flex_row radio-group-container g2 sticky-after base">
                <div className="display_none_tablet flex_gsb"></div>
                {test.questions[0].answers.map((val, ind) => (
                    <div
                        className="flex_col align-items_center justify-items_center bg03 roundness_1 h52 w120 full-width_tablet"
                        key={ind}
                    >
                        <span>-{val.content}-</span>
                        <span>
                            {val.content === "A" && phrases?.["1000210"]}
                            {val.content === "B" && phrases?.["1000211"]}
                            {val.content === "C" && phrases?.["1000257"]}
                        </span>
                    </div>
                ))}
            </fieldset>

            <fieldset
                aria-label="group-container"
                className="radio-group-container flex_row flex_col_tablet align-items_center unset-align-items_tablet g2"
            >
                <div className="base flex_gsb">
                    {0 + 1 + ". " + test.questions[0].questionText}
                </div>
                <div className="flex_row radio-group g2">
                    {chunk1.map((ans, ind) => (
                        <div
                            key={ind}
                            className="radio-container flex_col align-items_center justify-items_center m0 px6 py2 bg03 roundness_1 full-width_tablet"
                        >
                            <input
                                type="radio"
                                value={ans.position}
                                checked={ans.position == selectedAns1}
                                onClick={() => handleChunks1(ans.position)}
                            />
                        </div>
                    ))}
                </div>
            </fieldset>
            <fieldset
                aria-label="group-container"
                className="radio-group-container flex_row flex_col_tablet align-items_center unset-align-items_tablet g2"
            >
                <div className="base flex_gsb">
                    {1 + 1 + ". " + test.questions[1].questionText}
                </div>
                <div className="flex_row radio-group g2">
                    {chunk1.map((ans, ind) => (
                        <div
                            key={ind}
                            className="radio-container flex_col align-items_center justify-items_center m0 px6 py2 bg03 roundness_1 full-width_tablet"
                        >
                            <input
                                id={`option-${ans.id}`}
                                type="radio"
                                name={ans.id}
                                value={ans.position}
                                checked={ans.position == selectedAns2}
                                onClick={() => handleChunks2(ans.position)}
                            />
                        </div>
                    ))}
                </div>
            </fieldset>
            <fieldset
                aria-label="group-container"
                className="radio-group-container flex_row flex_col_tablet align-items_center unset-align-items_tablet g2"
            >
                <div className="base flex_gsb">
                    {2 + 1 + ". " + test.questions[2].questionText}
                </div>
                <div className="flex_row radio-group g2">
                    {chunk1.map((ans, ind) => (
                        <div
                            key={ind}
                            className="radio-container flex_col align-items_center justify-items_center m0 px6 py2 bg03 roundness_1 full-width_tablet"
                        >
                            <input
                                id={`option-${ans.id}`}
                                type="radio"
                                name={ans.id}
                                value={ans.position}
                                checked={ans.position == selectedAns3}
                                onClick={() => handleChunks3(ans.position)}
                            />
                        </div>
                    ))}
                </div>
            </fieldset>
            <fieldset
                aria-label="group-container"
                className="radio-group-container flex_row flex_col_tablet align-items_center unset-align-items_tablet g2"
            >
                <div className="base flex_gsb">
                    {3 + 1 + ". " + test.questions[3].questionText}
                </div>
                <div className="flex_row radio-group g2">
                    {chunk1.map((ans, ind) => (
                        <div
                            key={ind}
                            className="radio-container flex_col align-items_center justify-items_center m0 px6 py2 bg03 roundness_1 full-width_tablet"
                        >
                            <input
                                id={`option-${ans.id}`}
                                type="radio"
                                name={ans.id}
                                value={ans.position}
                                checked={ans.position == selectedAns4}
                                onClick={() => handleChunks4(ans.position)}
                            />
                        </div>
                    ))}
                </div>
            </fieldset>
        </React.Fragment>
    );
};

export default DisplayType3;
